import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/',
    name: 'defaultLink',
    component: () => import('../views/index.vue'),
    redirect: '/index',
    children: [
      {
        path: '/linzhou',
        name: 'homeLink',
        component: () => import('../views/linzhou.vue'),
        meta: {
          requireLogin: true
        }
      },
      {
        path: '/hebi',
        name: 'hebiLink',
        component: () => import('../views/hebi.vue'),
        meta: {
          requireLogin: true
        }
      },
      {
        path: '/henan',
        name: 'henanLink',
        component: () => import('../views/henan.vue'),
        meta: {
          requireLogin: true
        }
      },
      {
        path: '/index',
        name: 'aLink',
        component: () => import('../views/a.vue'),
        meta: {
          requireLogin: true
        }
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  next()
})

export default router



